export function extractErrorMessage(error: any, fallback?: string): string {
  const data = error?.response?.data;

  if (!data) return error?.message || fallback || 'An error occurred';

  if (typeof data === 'string') return data;

  if (typeof data.message === 'string') return data.message;

  if (typeof data.error === 'string') return data.error;

  if (typeof data.detail === 'string') return data.detail;

  if (data.message && typeof data.message === 'object') {
    if (typeof data.message.message === 'string') return data.message.message;
    try {
      return JSON.stringify(data.message);
    } catch (e) {
      // fallthrough
    }
  }

  try {
    return JSON.stringify(data);
  } catch (e) {
    return error?.message || fallback || 'An error occurred';
  }
}

export default extractErrorMessage;
